document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz) {
    return;
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  document.addEventListener('on:quickbuy:after-open', () => {
    if (!window.mz || !window.mz.track) {
      return;
    }
    Array.from(
      document.querySelectorAll('.form.js-product-form .btn.btn--large')
    ).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.form;
        if (!form) {
          return;
        }
        var uid = form.getAttribute('data-product-id');
        if (uid) {
          window.mz.track('add2cart', { uid: uid });
        }
      });
    });
  });

  var loadMoreFocusCardIndex = null;

  function getMezereonProductCards() {
    var grid = document.querySelector(
      '.mezereon .mz-hits-grid, .mezereon .mz-hits .product-grid',
    );
    if (!grid) {
      return [];
    }
    return Array.from(grid.querySelectorAll('product-block, .product-block'));
  }

  function focusMezereonCard(card) {
    if (!card) {
      return;
    }
    var target =
      card.querySelector('a.product-link') ||
      card.querySelector('.product-block__title a');
    if (!target) {
      target = card;
      if (!card.hasAttribute('tabindex')) {
        card.setAttribute('tabindex', '-1');
      }
    }
    if (target && typeof target.focus === 'function') {
      target.focus();
    }
  }

  function focusFirstNewlyLoadedCard() {
    if (loadMoreFocusCardIndex === null) {
      return;
    }
    var index = loadMoreFocusCardIndex;
    loadMoreFocusCardIndex = null;
    var cards = getMezereonProductCards();
    var card = cards[index];
    if (!card) {
      return;
    }
    requestAnimationFrame(function () {
      focusMezereonCard(card);
    });
  }

  document.addEventListener(
    'keydown',
    function (e) {
      if (!e.target || !e.target.closest) {
        return;
      }
      if (!e.target.closest('.mz-paging-more button')) {
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ' && e.code !== 'Space') {
        return;
      }
      if (e.key === ' ' || e.code === 'Space') {
        e.preventDefault();
      }
      loadMoreFocusCardIndex = getMezereonProductCards().length;
    },
    true,
  );

  function closeHeaderSearch() {
    if (!document.body.classList.contains('show-search')) {
      return;
    }

    var searchCloseButton = document.querySelector('.main-search__close');
    if (searchCloseButton) {
      searchCloseButton.click();
      return;
    }

    document.body.classList.remove('show-search');
  }

  function isMzAutocompletePanelInteraction(target) {
    return !!target.closest('#mz-autocomplete .mz-autocomplete-container');
  }

  function isMzAutocompleteDismissControl(target) {
    return !!target.closest('.mz-autocomplete-close, [aria-label="close autocomplete"]');
  }

  function bindHeaderSearchCloseTriggers() {
    // Close the theme search banner only for clicks outside the combined
    // main-search + MZ autocomplete experience — not for in-panel actions
    // such as list/grid toggles, suggestions, or product links.
    document.addEventListener(
      'click',
      function (e) {
        if (!document.body.classList.contains('show-search')) {
          return;
        }
        if (!e.target || !e.target.closest) {
          return;
        }
        if (e.target.closest('.main-search')) {
          return;
        }
        if (isMzAutocompletePanelInteraction(e.target)) {
          return;
        }
        closeHeaderSearch();
      },
      true,
    );

    document.addEventListener(
      'submit',
      function (e) {
        if (!document.body.classList.contains('show-search')) {
          return;
        }
        if (!e.target || !e.target.closest) {
          return;
        }
        if (!e.target.closest('.main-search__form')) {
          return;
        }
        closeHeaderSearch();
      },
      true,
    );
  }

  function isMezereonSearchPage() {
    return (
      document.body.classList.contains('template-suffix-mezereon-search') ||
      window.location.pathname.indexOf('/pages/search-results') !== -1
    );
  }

  var emptySearchNostoLoaded = false;

  function getMezereonSearchTerm() {
    try {
      return new URLSearchParams(window.location.search).get('q') || '';
    } catch (e) {
      return '';
    }
  }

  if (isMezereonSearchPage()) {
    window.nostojs = window.nostojs || function (cb) {
      (window.nostojs.q = window.nostojs.q || []).push(cb);
    };
  }

  function reloadEmptySearchNosto() {
    if (!isMezereonSearchPage()) {
      return;
    }
    nostojs(function (api) {
      var tagging = document.querySelector('.nosto_search_term');
      if (tagging) {
        tagging.textContent = getMezereonSearchTerm();
      }
      api.loadRecommendations();
    });
  }

  function setEmptySearchResultsHidden(isEmpty) {
    if (!isMezereonSearchPage()) {
      return;
    }
    var app = document.getElementById('mz-app');
    if (app) {
      app.classList.toggle('mz-search-empty', isEmpty);
    }
    var wrapper = document.getElementById('mz-empty-search-nosto');
    if (wrapper) {
      wrapper.hidden = !isEmpty;
    }
  }

  function updateEmptySearchNosto() {
    if (!isMezereonSearchPage()) {
      return;
    }

    var wrapper = document.getElementById('mz-empty-search-nosto');
    if (!wrapper) {
      return;
    }

    if (mz.app.loading) {
      setEmptySearchResultsHidden(false);
      return;
    }

    var items = mz.app.hits && mz.app.hits.items;
    var isEmpty = Array.isArray(items) && items.length === 0;
    setEmptySearchResultsHidden(isEmpty);

    if (!isEmpty) {
      emptySearchNostoLoaded = false;
      return;
    }

    if (emptySearchNostoLoaded) {
      return;
    }

    emptySearchNostoLoaded = true;
    reloadEmptySearchNosto();
  }

  function afterUpdate() {
    closeHeaderSearch();

    const quickbuyCloseButton = document.querySelector(
      '.expanded .quickbuy-container .close-detail'
    );
    if (quickbuyCloseButton) {
      if (typeof window.observer !== 'undefined') {
        quickbuyCloseButton.click();
      }
    }
    const loadMoreButton = document.querySelector('.mz-paging-more button');
    if (loadMoreButton) {
      loadMoreButton.classList.add('btn');
    }

    focusFirstNewlyLoadedCard();
    if (isMezereonSearchPage()) {
      updateEmptySearchNosto();
    }

    document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  }

  // Space/Enter support for filter toggles and drawer close.
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.code !== 'Space' && e.key !== 'Enter') return;

    var el = e.target.closest('a.toggle-btn, .mz-filter-btn, .ch-drawer__close-btn');
    if (!el) return;

    // Native <a> tags handle Enter; only intercept Space for them.
    if (el.tagName === 'A' && e.key === 'Enter') return;

    e.preventDefault();
    var clickTarget = el.querySelector('a.mz-filter') || el;
    clickTarget.click();
  });

  bindHeaderSearchCloseTriggers();

  if (mz.app && mz.app.$bus) {
    // Fires as soon as MZ starts a search query — before after-query / after-update.
    mz.app.$bus.on('run-query', function () {
      closeHeaderSearch();
      if (isMezereonSearchPage()) {
        emptySearchNostoLoaded = false;
        setEmptySearchResultsHidden(false);
      }
    });
    mz.app.$bus.on('after-update', afterUpdate);

    if (isMezereonSearchPage()) {
      // Fire immediately when queries complete (faster than waiting for after-update / nextTick)
      mz.app.$bus.on('after-initial-query', updateEmptySearchNosto);
      mz.app.$bus.on('after-query', updateEmptySearchNosto);

      if (typeof mz.app.$watch === 'function') {
        mz.app.$watch(
          function () {
            return {
              loading: mz.app.loading,
              itemsCount: mz.app.hits && mz.app.hits.items ? mz.app.hits.items.length : null
            };
          },
          function (state) {
            if (!state.loading && state.itemsCount === 0) {
              updateEmptySearchNosto();
            }
          }
        );
      }

      updateEmptySearchNosto();
    }

    var mzFilterOpener = null;
    mz.app.$bus.on('toggle-portal-nav', function (isOpen) {
      if (isOpen) {
        mzFilterOpener = document.activeElement;
        setTimeout(function () {
          var closeBtn = document.querySelector('.mz-drawer .ch-drawer__close-btn');
          if (closeBtn) {
            closeBtn.tabIndex = 0;
            closeBtn.focus();
          }
        }, 500);
      } else {
        if (mzFilterOpener) mzFilterOpener.focus();
        mzFilterOpener = null;
      }
    });
  }
});

// filter visibility
toggleFilter = function (el) {
  var aggs = document.querySelector('.mz-results');
  if (!aggs) {
    return false;
  }
  var isCollapsed = aggs.classList.toggle('mz-collapsed-filter');

  if (el && el.setAttribute) {
    el.setAttribute('aria-expanded', !isCollapsed);
  }

  return false;
};
